// extracted by mini-css-extract-plugin
export default {"subtext":"ImageSubText_subtext__VcOrr","imageContainer":"ImageSubText_imageContainer__TCiHr","image":"ImageSubText_image__W8wL7","container":"ImageSubText_container__8M9dX"};